<template>
  <ReportSimpleDataTable
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'warehouse',
        title: 'Warehouse',
        valueFieldName: '',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportSimpleDataTable from "@/own/components/reports/ReportSimpleDataTable.vue";
export default {
  name: "OrderReport",
  components: { ReportSimpleDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/orderReport",
      show_url: "/reports/orderReport/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
